import { api } from './api';
import { logEvent } from '../helpers/analytics';

export function fetchDashboard() {
  return dispatch => {
    return api.get('/api/modules/dashboard').then(response => {
      dispatch({ type: 'DASHBOARD_MODULE_FETCHED', payload: response });
    });
  };
}

export function updateDashboardData(data) {
  return dispatch => {
    return api.put('/api/modules/dashboard', data).then(response => {
      dispatch({ type: 'DASHBOARD_MODULE_FETCHED', payload: response });
    });
  };
}

export function nextIntroStep(value) {
  return dispatch => {
    dispatch({ type: 'DASHBOARD_NEXT_INTRO_STEP', intro_step: value });
    return api.put('/api/modules/dashboard', { intro_step: value });
  };
}

export function completeDashboardIntro() {
  return dispatch => {
    dispatch({ type: 'DASHBOARD_INTRO_COMPLETED' });
    return api.put('/api/modules/dashboard/complete_intro');
  };
}

export function scheduleAppointment(data) {
  return dispatch => {
    const { phone_number, date } = data;
    const body = {
      phone_number: phone_number.value,
      date: date.value.toString(),
    };
    return api.post('/api/appointments', body).then(response => {
      dispatch({ type: 'APPOINTMENT_SCHEDULED', payload: response });
    });
  };
}
